// app/middleware/notFoundAmericas.ts

export default defineNuxtRouteMiddleware((from, to) => {
  if (to.params.region === "americas") {
    throw createError({ statusCode: 404 });
  }
});
